// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WidgetWrapper_wrapper__2ONFM","clickable":"WidgetWrapper_clickable__3rICV"};